export var DEFAULT_BACKEND_HOST = 'https://api.cloud.ru';
export var DEFAULT_BASE_URL = 'https://cloud.ru';
export var DEFAULT_HEADERS = {
  'Content-Type': 'application/json;charset=utf-8'
};